"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const defaultConfig = {
    lighthouseBLSNode: "https://encryption.lighthouse.storage",
    lighthouseAuthNode: "https://encryption.lighthouse.storage",
    lighthouseBLSNodeDev: "http://enctest.lighthouse.storage",
    isDev: false,
};
exports.defaultConfig = defaultConfig;
exports.default = defaultConfig;
